import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CardHeader from '@material-ui/core/CardHeader';

const styles = theme => ({
  buttonLink: {
    width: '100%',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing.unit * 2,
  },
  cardActions: {
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing.unit * 2,
    },
  },
});

function PricingCard({ classes, pricing, value, formatMessage }) {
  return (
    <Grid item xs={12} sm={6} md={6}>
      <Card>
        <CardHeader
          title={pricing.title}
          titleTypographyProps={{ align: 'center' }}
          subheaderTypographyProps={{ align: 'center' }}
          className={classes.cardHeader}
        />
        <CardContent>
          <div className={classes.cardPricing}>
            <Typography variant="h6" color="textSecondary">
              {formatMessage('from')}{' '}
            </Typography>
            <Typography component="h2" variant="h3" color="textPrimary">
              ${parseInt(value, 10)}
            </Typography>
            <Typography variant="h6" color="textSecondary">
              {formatMessage('/mo')}
            </Typography>
          </div>
          {pricing.availables.map(line => (
            <Typography variant="subtitle1" align="center" key={line}>
              {formatMessage(line)}
            </Typography>
          ))}
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Link to="/" className={classes.buttonLink}>
            <Button fullWidth variant={pricing.buttonVariant} color="primary">
              {formatMessage(pricing.buttonText)}
            </Button>
          </Link>
        </CardActions>
      </Card>
    </Grid>
  );
}

PricingCard.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  pricing: PropTypes.shape({}).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  formatMessage: PropTypes.func.isRequired,
};

export default withStyles(styles)(PricingCard);
